import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ApplicationConfiguration =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ApplicationConfiguration, _BaseData);

  function ApplicationConfiguration() {
    _classCallCheck(this, ApplicationConfiguration);

    return _possibleConstructorReturn(this, _getPrototypeOf(ApplicationConfiguration).call(this, "ApplicationConfiguration"));
  }

  _createClass(ApplicationConfiguration, [{
    key: "GetHolidaysByDate",
    value: function () {
      var _GetHolidaysByDate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(startDate, endDate) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetHolidaysByDate"), {
                  params: {
                    endDate: endDate,
                    startDate: startDate
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetHolidaysByDate(_x, _x2) {
        return _GetHolidaysByDate.apply(this, arguments);
      }

      return GetHolidaysByDate;
    }()
  }]);

  return ApplicationConfiguration;
}(BaseData);

export default new ApplicationConfiguration();